import { AccountCircleRounded, Logout } from '@mui/icons-material';
import { Box, List, ListItem, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { getIsReOpsUser, userActions } from 'entities/User';
import { useNavigationBlock } from 'features/NavigationBlockModal/ui/NavigationBlockProvider/NavigationBlockProvider';
import { SearchVersionPreferenceMenuItems } from 'features/SearchVersionPreference';
import {
    shouldShowSearchVersionDebug,
    shouldShowVersionInfo,
} from 'shared/const/envVariables';
import { getRouteMain, getRouteProfile } from 'shared/const/router';
import { useAppDispatch } from 'shared/lib/hooks/useAppDispatch';
import { AppLink } from 'shared/ui/AppLink/AppLink';
import { VersionInfo } from 'widgets/VersionInfo';

const listItemStyles = {
    sx: {
        padding: 0,
        ':hover': {
            bgcolor: 'action.hover',
            cursor: 'pointer',
        },
    },
};

const listItemContentStyles = {
    width: '100%',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    padding: '0 16px',
};

export const AccountMenuItems = () => {
    const { t } = useTranslation();
    const { validateNavBlock } = useNavigationBlock();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const isReOpsUser = useSelector(getIsReOpsUser);
    const showSearchVersionDebug = shouldShowSearchVersionDebug(isReOpsUser);

    const onLogout = () => {
        validateNavBlock(async () => {
            dispatch(userActions.logout());
            navigate(getRouteMain());
        }, true);
    };

    return (
        <List
            sx={{
                padding: 0,
            }}
        >
            <ListItem {...listItemStyles}>
                <Box
                    component={AppLink}
                    to={getRouteProfile()}
                    replace
                    onClick={(e: React.MouseEvent) => {
                        e.preventDefault();
                        validateNavBlock(() => {
                            navigate(getRouteProfile());
                        }, true);
                    }}
                    {...listItemContentStyles}
                >
                    <AccountCircleRounded color="primary" />
                    <Typography
                        component="span"
                        variant="body1"
                        display="inline-block"
                        flex="1"
                        marginLeft="12px"
                    >
                        {t('Profile')}
                    </Typography>
                </Box>
            </ListItem>

            {showSearchVersionDebug && <SearchVersionPreferenceMenuItems />}

            <ListItem onClick={onLogout} {...listItemStyles}>
                <Box {...listItemContentStyles}>
                    <Logout color="action" />
                    <Typography variant="body1" flex="1" marginLeft="12px">
                        {t('Sign Out')}
                    </Typography>
                </Box>
            </ListItem>
            {shouldShowVersionInfo() && (
                <Box
                    sx={{
                        borderTop: '1px solid',
                        borderColor: 'divider',
                        padding: '8px 16px 12px',
                    }}
                >
                    <Typography
                        variant="caption"
                        sx={{
                            display: 'block',
                            color: 'text.secondary',
                        }}
                    >
                        <VersionInfo />
                    </Typography>
                </Box>
            )}
        </List>
    );
};
